namespace $.$$ {

	$mol_style_define( $shm_hitalama_page, {

		position: 'relative',
		overflow: 'visible',
		flex: {
			shrink: 0,
		},

	} )

}
